import DefaultModal from 'components/Modal/DefaultModal';
import { LuEye } from 'react-icons/lu';
import React, { useEffect, useState } from 'react';

export const TimeLineStageLeadModal = ({
  stageChanges,
  name,
  title,
  currentStage,
  responsible
}) => {
  const [show, setShow] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [timeline, setTimeline] = useState([]);

  useEffect(() => {
    if (show && stageChanges) {
      handleGetTimeLineReceivedCall(stageChanges);
    }
  }, [show, stageChanges]);

  const handleGetTimeLineReceivedCall = async (stageChanges) => {
    setTimeline(stageChanges);
  };

  return (
    <>
      <DefaultModal
        show={show}
        onModalToggle={setShow}
        title={title ? `Oportunidade: ${title}` : `Lead: ${name}`}
        subtitle={
          <>
            {`Fase atual: ${currentStage}`}
            <br />
            {`Responsável: ${responsible}`}
          </>
        }
        modalContainerClasses="modal-sm"
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '90%',
              flexDirection: 'column',
              flexWrap: 'wrap'
            }}
          >
            {timeline &&
              timeline.map((option, index) => {
                return (
                  <div
                    key={index}
                    className="timeline timeline-one-side mx-0"
                    data-timeline-axis-style="dotted"
                  >
                    <div className="timeline-block pb-5">
                      <span
                        className="timeline-step"
                        style={{ backgroundColor: '#5bc0de' }}
                      >
                        <i
                          className={'fas fa-exchange-alt'}
                          //	fas fa-exchange-alt/	fas fa-level-down-alt/ fas fa-share
                          style={{ color: 'white' }}
                        ></i>
                      </span>
                      <div
                        className="timeline-content"
                        style={{ maxWidth: '50rem' }}
                      >
                        <strong>{option?.stageName}</strong>
                      </div>
                      <small
                        className="text-muted font-weight-bold mt-2"
                        style={{ marginLeft: '3.8rem' }}
                      >
                        <i className="fas fa-clock mr-2"></i>
                        {option?.movedAt}
                      </small>
                      <small
                        className="text-muted font-weight-bold mt-2"
                        style={{ marginLeft: '3.8rem' }}
                      >
                        <i className="fas fa-calendar-alt mr-2"></i>
                        {option?.stageTime}
                      </small>
                      <small
                        className="text-muted font-weight-bold mt-2"
                        style={{ marginLeft: '3.8rem' }}
                      >
                        <i className="fas fa-calendar-check mr-2"></i>
                        {option?.movedAtTime}
                      </small>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </DefaultModal>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <button
          onClick={() => setShow(true)}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <LuEye />
        </button>
        {showTooltip && (
          <div
            style={{
              position: 'absolute',
              top: '40px',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#fff',
              color: '#000',
              padding: '6px 10px',
              borderRadius: '4px',
              fontSize: '12px',
              border: '1px solid #ddd',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              whiteSpace: 'nowrap',
              zIndex: 1000
            }}
          ></div>
        )}
      </div>
    </>
  );
};
